// boot.ts

import { useAccessStore } from "../store/useAccessStore";
import { useDeviceStore } from "../store/useDeviceStore";
import { detectDeviceType } from "./deviceUtils";

export function bootstrapDeviceType() {
  if (typeof window === "undefined") return; // SSR 가드
  const current = useDeviceStore.getState().deviceType;
  // 이미 저장되어 있어도, 쿼리/주입값이 있으면 우선 반영(최초 진입 보정)
  const detected = detectDeviceType();
  if (current !== detected) {
    useDeviceStore.getState().setDeviceType(detected);
  }
}

export const pushTokenActions = {
  android: () => {
    window.VoicePark?.onRequestPushTokenToServer?.();
  },
  ios: () => {
    window.webkit?.messageHandlers?.onRequestPushTokenToServer?.postMessage(
      JSON.stringify({}),
    );
  },
  web: () => {},
};

// 네이티브 FCM 토큰 등록 요청을 짧은 시간 내 중복 호출하지 않도록 막는 간격
const FCM_TRIGGER_THROTTLE_MS = 60 * 1000;
let lastFcmTriggerAt = 0;

/**
 * 네이티브에 FCM 토큰 발급을 요청한다. 발급된 토큰은 네이티브가
 * handlePushToServer로 돌려주어 PUT /v1/auth/fcm-token 으로 저장된다.
 *
 * - 저장 PUT은 인증이 필요하므로 로그인 상태에서만 트리거한다.
 * - 포그라운드 복귀 등으로 잦은 호출이 발생할 수 있어 기본적으로 throttle한다.
 *   로그인/회원가입 직후처럼 즉시 등록이 필요한 경우 force로 우회한다.
 */
export function requestPushTokenRegistration(options?: { force?: boolean }) {
  if (typeof window === "undefined") return;

  const hasToken = !!useAccessStore.getState().access?.accessToken;
  if (!hasToken) return;

  const now = Date.now();
  if (!options?.force && now - lastFcmTriggerAt < FCM_TRIGGER_THROTTLE_MS) {
    return;
  }
  lastFcmTriggerAt = now;

  const deviceType = useDeviceStore.getState().deviceType;
  pushTokenActions[deviceType]?.();
}
